import { TeacherFocusBuilder } from '@/lib/store/builder-store.types'
import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'
import { checkTypeCardActivity } from '@/utils/checkTypeCard'

const REPEAT_TEACHER_FOCUS = [TeacherFocusBuilder.PROMPT, TeacherFocusBuilder.ANSWER]
const RESPOND_TEACHER_FOCUS = [TeacherFocusBuilder.PROMPT, TeacherFocusBuilder.GRADING, TeacherFocusBuilder.ANSWER]
const MC_TEACHER_FOCUS = [TeacherFocusBuilder.ANSWER]
const SHORT_ANSWER_TEACHER_FOCUS = [TeacherFocusBuilder.PROMPT, TeacherFocusBuilder.GRADING, TeacherFocusBuilder.ANSWER,]

export function checkActiveTeacherFocus(card: CardActivityWithId | undefined, teacherFocus: TeacherFocusBuilder) {
  const { isMC, isRepeat, isRespond, isShortAnswer } = checkTypeCardActivity(card?.type)

  if (TeacherFocusBuilder.GENERAL === teacherFocus) {
    return true
  }

  if (isMC) {
    return MC_TEACHER_FOCUS.includes(teacherFocus)
  }

  if (isRepeat) {
    return REPEAT_TEACHER_FOCUS.includes(teacherFocus)
  }

  if (isRespond) {
    return RESPOND_TEACHER_FOCUS.includes(teacherFocus)
  }

  if (isShortAnswer) {
    return SHORT_ANSWER_TEACHER_FOCUS.includes(teacherFocus)
  }
}
